import { render } from "./LicenceAgreement.vue?vue&type=template&id=7a067486&scoped=true&lang=html"
import script from "./LicenceAgreement.vue?vue&type=script&lang=js"
export * from "./LicenceAgreement.vue?vue&type=script&lang=js"

import "./LicenceAgreement.vue?vue&type=style&index=0&id=7a067486&scoped=true&lang=scss"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a067486"]])

export default __exports__